<template>
  <div class="dimed wrap" v-if="emoneySelectYn == true">
    <div class="layer" :class="{'layer--bottom': currentUrl.indexOf('idle') >= 0}">
      <!-- header -->
      <div class="layer__header fix-h">
        <div class="lyr-title">{{ $t('Modal.EMoneySelect.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.EMoneySelect.msg2') }}</div>
      </div>
      <!-- //header -->
      <!-- body -->
      <div class="layer__body">
        <div class="menu__event">
          <!-- one item -->
          <!-- 체크되면 아래 요소에 on 클래스 추가, span.ico-checked 요소 추가 -->
          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY200') >= 0" @mouseup="$emit('setEmoneyStatus', 'PAY200')">
            <!-- <span class="ico-checked">checked</span> -->
            <div>
              <img src="@/assets/images/user/logo-ic.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">交通系IC</span>
            </div>
          </div>
          <!-- //one item -->

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY205') >= 0" @mouseup="$emit('setEmoneyStatus', 'PAY205')">
            <!-- <span class="ico-checked">checked</span> -->
            <div>
              <img src="@/assets/images/user/logo-waon.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">WAON</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY202') >= 0" @mouseup="$emit('setEmoneyStatus', 'PAY202')">
            <!-- <span class="ico-checked">checked</span> -->
            <div>
              <img src="@/assets/images/user/logo-nanaco.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">nanaco</span>
            </div>
          </div>

          <div class="touchbox touchbox--port border btn-anim" v-if="supportPayments.indexOf('PAY204') >= 0" @mouseup="$emit('setEmoneyStatus', 'PAY204')">
            <!-- <span class="ico-checked">checked</span> -->
            <div>
              <img src="@/assets/images/user/logo-edy.png" alt="" />
            </div>
            <div class="row__txt">
              <span class="ft--lg">Edy</span>
            </div>
          </div>
        </div>
      </div>
      <!-- //body -->

      <div class="layer__button">
        <button class="btn btn--line btn--xlg btn-anim" @mouseup="$emit('closeEmoneySelect')">{{ $t('Modal.EMoneySelect.msg3') }}</button>
      </div>
    </div>
    <!-- //modal -->
  </div>
</template>
<script>
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'emoneySelect',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      currentUrl: window.location.pathname,
      //결제 방법 종류
      supportPayments: this.$store.getters.getPosConfig.posConfig.supportPayments,
    };
  },
  mounted() {},
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    emoneySelectYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00051', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
  props: {
    emoneySelectYn: Boolean,
    //emoney: Number,
  },
  methods: {},
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/intro.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/intro-dark.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>

<style scoped>
.touchbox.touchbox--port {
  position: relative;
  width: 29.63vw;
  min-height: 8vh;
  margin-bottom: var(--txt-pd20);
  display: flex;
  border: 4px solid #fff;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ico-checked {
  width: var(--iconsize-xsm);
  height: var(--iconsize-xsm);
  text-indent: 100%;
  white-space: nowrap;
  overflow: hidden;
  background: url('@/assets/images/user/ico-check.png') no-repeat;
  background-size: 100% auto;
}
</style>
